/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 10:10:34
 * @LastEditors: chenkang
 * @LastEditTime: 2022-06-15 17:18:40
 */
// import {permissonRoutes} from '../../router';
import XLSX from "xlsx";//需要引入包
console.log('XLSX',XLSX)
export let listroute = {}
export default {
    timeformat(date,format){
        date = typeof date ==='string' ? date.replace(/-/igm,'/') :date;
        let data = new Date(date);
        let time = {
            'M+':data.getMonth() + 1 < 10 ? '0'+ (data.getMonth() + 1) : data.getMonth() + 1,
            'd+':data.getDate() < 10 ? '0'+data.getDate() : data.getDate(),
            'h+':data.getHours(),
            'm+':data.getMinutes() < 10 ? '0'+data.getMinutes() : data.getMinutes(),
            's+':data.getSeconds() < 10 ? '0'+data.getSeconds() : data.getSeconds(),
            'q+':Math.floor((data.getMonth() + 3) / 3),
        }
        if(/(y+)/i.test(format)){
            format = format.replace(RegExp.$1,(data.getFullYear()+"").substr(4 - RegExp.$1.length))
        }
        for(let k in time){
            if(new RegExp('('+k+')').test(format)){
                format = format.replace(RegExp.$1,RegExp.$1.length === 1 ? time[k] : ('00'+time[k]).substr((''+time[k]).length))
            }
        }
        
        return format
    },
    /**加法 */
    addition(arg1,arg2){
        let length1 = arg1.toString().indexOf(".") != -1 ? arg1.toString().split(".")[1].length :1
        let length2 = arg2.toString().indexOf(".") != -1 ? arg2.toString().split(".")[1].length :1
        let m = Math.pow(10, Math.max(length1, length2))
        let n = (length1 >= length2) ? length1 : length2;
        return ((arg1 * m + arg2 * m) / m).toFixed(n);
    },
    /**减法 */
    subtraction(arg1,arg2){
        let length1 = arg1.toString().indexOf(".") != -1 ? arg1.toString().split(".")[1].length :1
        let length2 = arg2.toString().indexOf(".") != -1 ? arg2.toString().split(".")[1].length :1
        let m = Math.pow(10, Math.max(length1, length2))
        let n = (length1 >= length2) ? length1 : length2;
        return (((arg1 * m) - (arg2 * m)) / m).toFixed(n);
    },
    /**乘法 */
    multiplication(arg1,arg2){
        let m=0,s1=arg1.toString(),s2=arg2.toString();
        try{m+=s1.split(".")[1].length}catch(e){}
        try{m+=s2.split(".")[1].length}catch(e){}
        return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
    },
    /**除法 */
    division(arg1,arg2){
        let length1 = arg1.toString().indexOf(".") != -1 ? arg1.toString().split(".")[1].length :1
        let length2 = arg2.toString().indexOf(".") != -1 ? arg2.toString().split(".")[1].length :1
        let m = Math.pow(10, Math.max(length1, length2))
        let n = (length1 >= length2) ? length1 : length2;
        return (((arg1 * m) / (arg2 * m)) ).toFixed(2);
    },
    /**数组去重 */
    duplication(list,id){
        const res = new Map();
        return list.filter((arr) => !res.has(arr[id]) && res.set(arr[id], 1));
    },
    downLoadFile(src,name){
        const url = src;
        const suffix = url.substring(url.lastIndexOf("."), url.length);
        
        const x = new XMLHttpRequest();
        x.open("GET", url, true);
        x.responseType = 'blob';
        x.onload=function(e) {
            const url = window.URL.createObjectURL(x.response);
            const a = document.createElement('a');
            a.href = url;
            a.download = name;
            a.click()
        };
        x.send();
    },
    /**子节点重命名 */
    recursion(data){
        return data.map(v=>{
            let children = []
            Object.keys(v).map(s=>{
                if(Array.isArray(v[s])){
                    v.children = v[s]|| []
                }
            })
            if(v.children && v.children.length !== 0){
                children = this.recursion(v.children)
            }
            v.children = children
            return v
        })
    },
    /**判断登陆权限 */
    judgeRoture(permissonRoutes,jurisdictionlist){
        let list = permissonRoutes.filter((v:any)=>{
            let ishas = jurisdictionlist.some((i:any)=>{
                return v.meta.alias.includes(i)
            })
            if(v.children && v.children.length !== 0){
                v.children = this.judgeRoture(v.children,jurisdictionlist)
            }
            return ishas
        })
        return list
    },
    /**获取路由里的所有权限 */
    allrouter(arr){
        arr.map(v=>{
            if(v.meta && v.meta.alias && v.meta.alias.length == 1){
                listroute[v.meta.alias] = true
            }
            if(v.children && v.children.length> 0){
                this.allrouter(v.children)
            }
        })
    },
    /**删除所有获取的路由 */
    cleanrouter(){
        listroute = {}
    },
    /**读取excel */
    getExcelData (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
      
          reader.onload = function (e) {
            const data = e.target.result
            const wb = XLSX.read(data, { type: 'binary' })
            const jsonData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
      
            resolve(jsonData)
          }
          reader.onerror = () => reject('错误的文件类型!')
          reader.readAsBinaryString(file)
        })
      }
  
}


// WEBPACK FOOTER //
// ./src/common/util/minxi.ts